import { useSpring, animated } from '@react-spring/web'
import cn from 'clsx'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Innovative: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style_1, api_1] = useSpring(() => ({
		from: {
			x: 0,
			y: 0,
		},
		config: {
			duration: 800,
		},
	}))
	const [style_2, api_2] = useSpring(() => ({
		from: {
			x: 0,
			y: 0,
		},
		config: {
			duration: 800,
		},
	}))
	const [style_3, api_3] = useSpring(() => ({
		from: {
			x: 0,
			y: 0,
		},
		config: {
			duration: 800,
		},
	}))
	const [style_4, api_4] = useSpring(() => ({
		from: {
			x: 0,
			y: 0,
		},
		config: {
			duration: 800,
		},
	}))
	const [style_5, api_5] = useSpring(() => ({
		from: {
			x: 0,
			y: 0,
		},
		config: {
			duration: 800,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all([
				api_1.start({
					to: [
						{
							x: -50,
						},
						{
							x: 0,
						},
						{
							x: -50,
						},
						{
							x: 0,
						},
					],
				}),
				api_2.start({
					to: [
						{
							x: 50,
						},
						{
							x: 0,
						},
						{
							x: 50,
						},
						{
							x: 0,
						},
					],
				}),
				api_3.start({
					to: [
						{
							x: 50,
							y: -50,
						},
						{
							x: 0,
							y: 0,
						},
						{
							x: 50,
							y: -50,
						},
						{
							x: 0,
							y: 0,
						},
					],
				}),
				api_4.start({
					to: [
						{
							x: -50,
							y: -50,
						},
						{
							x: 0,
							y: 0,
						},
						{
							x: -50,
							y: -50,
						},
						{
							x: 0,
							y: 0,
						},
					],
				}),
				api_5.start({
					to: [
						{
							y: -50,
						},
						{
							y: 0,
						},
						{
							y: -50,
						},
						{
							y: 0,
						},
					],
				}),
			]).catch(console.error)
		}
	}, [animate, api_1, api_2, api_3, api_4, api_5])

	return (
		<animated.span
		// style={style}
		>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path // ???
					d="m142.13,221.13h-.52l1.76,2.2c-.43-.72-.84-1.46-1.24-2.2Z"
				/>
				<path // frame
					className={cn('transition duration-300 ease-in-out', {
						'fill-accent-3': animate,
					})}
					d="m289.64,184.21c0,13.35-3.37,25.92-9.31,36.92-.23.42-.66,1.22-1.24,2.2-4.22,7.21-8.51,11.88-9.71,13.24-6.04,6.85-9.78,16.14-12.28,22.37-2.45,6.11-5.35,15.14-6.55,26.7v40.12c0,3.47-1.81,6.52-4.54,8.26-.19,2.3-1.63,16.77-14.08,25.8-11.83,8.58-28.57,8.58-40.4,0-12.45-9.03-13.89-23.5-14.08-25.8-2.73-1.74-4.54-4.79-4.54-8.26v-40.12c-1.2-11.56-4.09-20.59-6.55-26.7-2.58-6.43-6.25-15.57-12.26-22.35-1.16-1.31-5.49-6.01-9.73-13.26-.58-.98-1.01-1.78-1.24-2.2-5.94-11-9.31-23.57-9.31-36.92,0-42.96,34.94-77.91,77.9-77.91h.02c42.96,0,77.9,34.95,77.9,77.91Z"
				/>
				<line // 1. line from bottom
					x1="177.45"
					y1="334.02"
					x2="246.01"
					y2="334.02"
				/>
				<line // 2. line from bottom
					x1="172.91"
					y1="317.09"
					x2="250.55"
					y2="317.09"
				/>
				<line // 3. line from bottom
					x1="173.03"
					y1="300.15"
					x2="250.67"
					y2="300.15"
				/>
				<animated.path // 1. line from left
					style={style_1}
					d="m118.12,198.82h-44.71c-1.96,0-3.84,1.72-3.75,3.75s1.65,3.75,3.75,3.75h44.71c1.96,0,3.84-1.72,3.75-3.75s-1.65-3.75-3.75-3.75h0Z"
				/>
				<animated.path // 1. line from right
					style={style_2}
					d="m350.29,198.82h-44.71c-1.96,0-3.84,1.72-3.75,3.75s1.65,3.75,3.75,3.75h44.71c1.96,0,3.84-1.72,3.75-3.75s-1.65-3.75-3.75-3.75h0Z"
				/>
				<animated.path // 2. line from right
					style={style_3}
					d="m324.1,104.45c-12.33,8.37-24.65,16.75-36.98,25.12-1.67,1.14-2.42,3.3-1.35,5.13.97,1.66,3.45,2.49,5.13,1.35,12.33-8.37,24.65-16.75,36.98-25.12,1.67-1.14,2.42-3.3,1.35-5.13-.97-1.66-3.45-2.49-5.13-1.35h0Z"
				/>
				<animated.path // 2. line from left
					style={style_4}
					d="m94.99,110.92c12.33,8.37,24.65,16.75,36.98,25.12,1.68,1.14,4.16.32,5.13-1.35,1.08-1.85.33-3.99-1.35-5.13-12.33-8.37-24.65-16.75-36.98-25.12-1.68-1.14-4.16-.32-5.13,1.35-1.08,1.85-.33,3.99,1.35,5.13h0Z"
				/>
				<animated.path // middle line
					style={style_5}
					d="m208.16,46.02v44.71c0,1.96,1.72,3.84,3.75,3.75s3.75-1.65,3.75-3.75v-44.71c0-1.96-1.72-3.84-3.75-3.75s-3.75,1.65-3.75,3.75h0Z"
				/>
			</svg>
		</animated.span>
	)
}

export { Innovative }
